// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"managerReportCell_mulitpleDropdown__39iV3","text":"managerReportCell_text__3RAlE","target":"managerReportCell_target__1CuWU"};